// extracted by mini-css-extract-plugin
module.exports = {"addPost":"AddPost_addPost__TtveJ","addPostIcon":"AddPost_addPostIcon__D5RNW","addPostText":"AddPost_addPostText__S9mxE"};